module.exports = __webpack_public_path__ + "img/box-arrow-in-down.1a53b1ae.svg";